function definedNotNull<T>(arg: T | undefined | null): arg is NonNullable<T> {
  if (arg === undefined || arg === null) {
    return false;
  }
  return true;
}

export { definedNotNull };
